<div class="container">
    <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
    <table class="table table-hover table-last-col">
        <thead>
            <tr>
                <th>Naam</th>
                <th>E-mailadres</th>
                <th>Rollen</th>
                <th>Parttime tarief</th>
                <th>Start werkzaamheden</th>
                <th>Einde werkzaamheden</th>
            </tr>
        </thead>
        <tbody>
            @for (user of users(); track user) {
                <tr class="curpoint" routerLink="/{{Routenames.users}}/{{user.id}}">
                    <td>{{user.name}}</td>
                    <td>{{user.email}}</td>
                    <td>
                        @for (role of user.roles; track role.key) {
                            {{role.name}}
                        }
                    </td>
                    <td class="text-end">{{user.part_time_rate * 100 | number : '0.0-0'}}%</td>
                    <td class="text-end">{{user.employment_start | date:'EEE d MMM yyyy'}}</td>
                    <td class="text-end">{{user.employment_end | date:'EEE d MMM yyyy'}}</td>
                </tr>
            } @empty {
                <tr>
                    <td class="text-center" colspan="99">
                        @if (users() === null) {
                            Aan het laden...
                        } @else {
                            Geen gebruikers gevonden
                        }
                    </td>
                </tr>
            }
            <tr>
                <td colspan="99">
                    <button class="w-100" color="primary" mat-button routerLink="/{{Routenames.users}}/new">
                        Een gebruiker toevoegen <i class="fas fa-plus"></i>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
